import React from "react";
import { motion } from "framer-motion";
const Circle = ({ pct }) => {
    const r = 70;
    const circ = 2 * Math.PI * r;
    const strokePct = ((100 - pct) * circ) / 100;
    return (
        <>
            <circle
                r={r}
                cx={100}
                cy={100}
                fill="transparent"
                stroke="#E9E9E9" 
                strokeWidth={"2rem"}
            ></circle>
            <motion.circle
                r={r}
                cx={100}
                cy={100}
                fill="transparent"
                stroke='url(#gradient)' 
                strokeWidth={"2rem"}
                strokeDasharray={circ}
                strokeDashoffset={pct ? strokePct : 0}
                strokeLinecap="butt"
                animate={{ strokeDashoffset: pct ? strokePct : 0 }} 
            ></motion.circle>
        </>
    );
};

const Pie = ({ total, highlightedAmount, colour }) => {
    const pct = (highlightedAmount / total) * 100;

    return (
        <svg width="100%" height="100%" viewBox="0 0 200 200">
            <defs>
                <linearGradient id="gradient" gradientTransform="rotate(90)">
                    <stop offset="0%" stopColor="#BA62FF" />
                    <stop offset="40%" stopColor="#AA42FC" />
                    <stop offset="100%" stopColor="#7241FF" />
                </linearGradient>
            </defs>
            <g transform={`rotate(-90 ${"100 100"})`}>
                <Circle pct={pct} />
            </g>
        </svg>
    );
};

export default Pie;
